export const height = {
  full: '100%',
  half: '50%',
  quarter: '25%',

  xs: 24,
  sm: 32,
  md: 40,
  lg: 48,
  xl: 56,
  xxl: 64,

  inputSm: 40,
  input: 48,
  inputLg: 56,

  buttonSm: 32,
  button: 40,
  buttonLg: 48,

  auto: 'auto',
};

